import { render, staticRenderFns } from "./MilestoneEvaluations.vue?vue&type=template&id=2356de22&"
import script from "./MilestoneEvaluations.vue?vue&type=script&lang=js&"
export * from "./MilestoneEvaluations.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports